module.exports = __webpack_public_path__ + "img/1439254228.5495734e.jpg";